import { axiosInstance } from '@/modules/shared/lib/axios';

type Props = {
  companyId: string
  payload: {
    id: string
  }
}

type UpdateResponse = {
  success: boolean
  data?: {
    message?: string
  }
}

export function calculateViolation({ companyId, payload }: Props) {
  return axiosInstance.post<UpdateResponse>(`/api/${companyId}/violation/calculate`, { companyId, ...payload });
}
